// extracted by mini-css-extract-plugin
module.exports = {"bubble":"_ca96645a","icon":"_fc62286f","printLink":"_2c26f215"};